import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css';
import App from './App';
import './Fonts/PKMNRBYGSC.ttf'
import './Fonts/pokemon-hollow.ttf'
import './Fonts/pokemon-solid.ttf'


ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
